import { createFileRoute } from "@tanstack/react-router";
import IASetupView from "@/views/prompts/IASetupView";

export const Route = createFileRoute("/_dashboard/ia-setup")({
  component: IASetup,
});

function IASetup() {
  return <IASetupView />;
}
